<template>
  <div class="home-types relative-section">
    <img class="heber" src="../assets/images/hebergements.png" alt />
    <div class="container">
      <h2 class="relative-section text-center section-title font-balo font-bold">
        <span>{{landingPage.htype_subtitle ? landingPage.htype_subtitle : $t('app.découvrir')}}</span>
        <b>{{landingPage.htype_title ? landingPage.htype_title : $t('app.Nos types d’hébergements')}}</b>
      </h2>
      <div class="type-list" v-if="landingPage.htype_list && landingPage.htype_list.length > 0">
        <div
          class="type-item"
          v-for="(item, index) in landingPage.htype_list"
          :key="index"
          :class="{'type-item-other': (index + 1)%2 === 0}"
        >
          <div class="list-inline" v-if="(index + 1)%2 === 0">
            <div class="item-inline">
              <div class="info">
                <h3 class="font-balo font-bold">
                  <a href>{{item.name}}</a>
                </h3>
                <p v-html="item.description"></p>
              </div>
            </div>
            <div class="item-inline item-small">
              <div class="image-fit">
                <img :src="item.image_1" alt />
              </div>
            </div>
            <div class="item-inline item-large">
              <div class="image-fit">
                <img :src="item.image_2" alt />
              </div>
            </div>
          </div>
          <div class="list-inline" v-if="(index + 1)%2 !== 0">
            <div class="item-inline item-large">
              <div class="image-fit">
                <img :src="item.image_1" alt />
              </div>
            </div>
            <div class="item-inline item-small">
              <div class="image-fit">
                <img :src="item.image_2" alt />
              </div>
            </div>
            <div class="item-inline">
              <div class="info">
                <h3 class="font-balo font-bold">
                  <a href>{{item.name}}</a>
                </h3>
                <p v-html="item.description"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "LandingTypes",
  computed: {
    ...mapState({
      landingPage: state => get(state, "app.landingPage")
    })
  }
};
</script>
